import RequestManager from "./RequestManager";

const handleLoginResponse = (response) => {
    if (response && !response.error && response.data) {
        window.sessionStorage.setItem("authToken", response.data.token);
        window.sessionStorage.setItem(
            "refreshToken",
            response.data.refreshToken
        );
        window.sessionStorage.setItem("expiresAt", response.data.expiresAt);
    }
};

const login = async (body) => {
    const response = await RequestManager.post({
        url: "/auth/login/v1",
        body,
        headers: {
            grant_type: "authorization"
        }
    });

    handleLoginResponse(response);

    return response;
};

const loginToken = async (body) => {
    const response = await RequestManager.post({
        url: "/auth/login/token/v1",
        body
    });

    handleLoginResponse(response);

    return response;
};

const loginGuest = async (body) => {
    const response = await RequestManager.post({
        url: "/auth/login/guest/v1",
        body
    });

    handleLoginResponse(response);

    return response;
};

const resetPassword = async (body) => {
    return RequestManager.post({
        url: "/auth/resetPassword/v1",
        body
    });
};

const startTrial = async (body) => {
    return RequestManager.post({
        url: "/auth/startTrial/v1",
        body: {
            ...body,
        }
    });
};

const getNewToken = async () => {
    const refreshToken = window.sessionStorage.getItem("refreshToken");
    if (refreshToken) {
        clearAuthTokens();
        const response = await RequestManager.post({
            url: "/auth/login/v1",
            headers: {
                grant_type: "refresh_token",
                Authorization: refreshToken
            }
        });
        if (response && !response.error && response.data) {
            window.sessionStorage.setItem("authToken", response.data.token);
            window.sessionStorage.setItem(
                "refreshToken",
                response.data.refreshToken
            );
            window.sessionStorage.setItem("expiresAt", response.data.expiresAt);
            return true;
        }
    }
    return false;
};

const clearAuthTokens = () => {
    const keys = ["authToken", "refreshToken", "expiresAt"];
    for (const key of keys) {
        window.sessionStorage.removeItem(key);
    }
};

const logout = async () => {
    window.sessionStorage.clear();
    return true;
};

const Auth = {
    login,
    loginToken,
    loginGuest,
    resetPassword,
    startTrial,
    logout,
    getNewToken
};

export default Auth;
